import { Box, Button, ButtonGroup, CircularProgress, Grid, ListItem, Paper, Skeleton, TextField, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import DataTable from '../../components/tables/DataTable';
import { FilterTitleBox } from '../../components/layouts/OneViewBox';
import PaddingBoxInDesktop from '../../components/layouts/PaddingBoxDesktop';
import AsyncSearchBar from '../../components/inputs/AsyncSearchBar';
import { BUTTON_TYPE, STATUS } from '../../utils/constants';
import ButtonComponentsUi from './ButtonComponentsUi';
import { getProdutApi } from '../../apis/product.api';
import CustomInput from '../../components/inputs/CustomInputs';
import AsyncDropDown from '../../components/inputs/AsyncDropDown';
import { openModal } from '../../store/actions/modalAction';
import ProductController from './product-view/ProductController'
import { useDispatch } from 'react-redux';
const DashboardPageUI = ({ productid, setProductid, openModalloading, loadingCount, CountStatus, setSTATUSWiseData, STATUSWiseData, filters, setFilters, createTiket, setList, loading, list, columns, setCRMstatusButton, CRMstatusButton }) => {
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down("md"))
  const issmSmallScreen = useMediaQuery(theme => theme.breakpoints.down("sm"))
  const isSmallScreens = useMediaQuery('(max-width:1100px)');
  const key = `${CRMstatusButton}-${STATUSWiseData}`
  const dispatch = useDispatch();
  return (
    <>
      <Box  >
        <Paper sx={{ width: "100%", height: "85vh", overflow: (isSmallScreen || isSmallScreens) ? "auto" : "hidden", padding: (isSmallScreen || isSmallScreens) ? 4 : 6 }}>
          <Box>
            <FilterTitleBox >
              <Box mt={0} display={"flex"} flexDirection={"row"} justifyContent={"space-between"} width={"100%"}>
                <Box width={"77%"}>
                  <Typography variant="h3" color={"primary"}>
                    CRM Dashboard
                  </Typography>
                </Box>

                <Box display={"flex"} flexDirection={"row"} width={"25%"} justifyContent={"space-between"}>
                  <Box width={"40%"}>
                    <Button
                      disabled={openModalloading}
                      onClick={() => {
                        dispatch(
                          openModal(
                            <ProductController />,
                            "xl",
                            false,
                            "product"
                          )
                        );
                      }}
                      sx={{ width: "100%", height: "6vh" }} variant='outlined'>
                      <Typography variant='h5' sx={{ display: "flex" }}>
                        Product View
                      </Typography>
                    </Button>
                  </Box>
                  <Box width={"55%"}>
                  <Button
                    disabled={openModalloading}
                    onClick={() => {
                      createTiket();
                    }}
                    sx={{ width: "100%", height: "6vh" }} variant='contained'>
                    {openModalloading ? <Box sx={{ width: "10vw" }}><CircularProgress size={25} color={openModalloading ? "primary" : "light"} ml={4} /></Box>

                      : <>
                        <Typography variant='h5' sx={{ display: "flex" }}>
                          Add Query
                        </Typography></>}
                    </Button>
                  </Box>
                </Box>

              </Box>
            </FilterTitleBox>
          </Box>

          {loadingCount ?
            <Box mt={4} sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', height: "15vh" }}>
              {[0, 1, 2, 3].map((row) => (
                <Skeleton
                  key={row}
                  variant="rectangular"
                  width={!issmSmallScreen ? "24%" : "24%"}
                  height={120}
                  sx={{ borderRadius: "8px", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" }}
                />
              ))}
            </Box>
            : <Grid mt={4} md={12} xs={12} sm={12} container>
              <Box gap={4} sx={{ width: "100%", display: "flex", justifyContent: "space-between", flexDirection: !issmSmallScreen ? "row" : "column" }}>

                <Box width={!issmSmallScreen ? "24%" : "100%"} >
                  <ButtonComponentsUi onSubmit={() => { setCRMstatusButton(BUTTON_TYPE.pending); setSTATUSWiseData(STATUS.ALL) }}
                    count={((CountStatus?.response[0]?.count ?? 0) + (CountStatus?.response[3]?.count ?? 0)) ?? 0}
                    STATUSTypeData={BUTTON_TYPE.pending} colorType={CRMstatusButton === BUTTON_TYPE.pending} />
                </Box>
                <Box width={!issmSmallScreen ? "24%" : "100%"} >
                  <ButtonComponentsUi onSubmit={() => { setCRMstatusButton(BUTTON_TYPE.Work_In_Progress); setSTATUSWiseData(STATUS.ALL) }}
                    count={((CountStatus?.response[17]?.count ?? 0) + (CountStatus?.response[1]?.count ?? 0) + (CountStatus?.response[7]?.count ?? 0) + (CountStatus?.response[4]?.count ?? 0) + (CountStatus?.response[5]?.count ?? 0) ?? 0)} STATUSTypeData={BUTTON_TYPE.Work_In_Progress} colorType={CRMstatusButton === BUTTON_TYPE.Work_In_Progress} />
                </Box>
                <Box width={!issmSmallScreen ? "24%" : "100%"} >
                  <ButtonComponentsUi onSubmit={() => { setCRMstatusButton(BUTTON_TYPE.Solved); setSTATUSWiseData(STATUS.ALL) }}
                    count={((CountStatus?.response[6]?.count ?? 0) + (CountStatus?.response[15]?.count ?? 0) + (CountStatus?.response[14]?.count ?? 0) + (CountStatus?.response[9]?.count ?? 0) ?? 0)} STATUSTypeData={BUTTON_TYPE.Solved} colorType={CRMstatusButton === BUTTON_TYPE.Solved} />
                </Box>
                <Box width={!issmSmallScreen ? "24%" : "100%"} >
                  <ButtonComponentsUi
                    count={((CountStatus?.response[17]?.count ?? 0) + (CountStatus?.response[0]?.count ?? 0) + (CountStatus?.response[15]?.count ?? 0) + (CountStatus?.response[14]?.count ?? 0) + (CountStatus?.response[3]?.count ?? 0) + (CountStatus?.response[1]?.count ?? 0) + (CountStatus?.response[4]?.count ?? 0) + (CountStatus?.response[5]?.count ?? 0) + (CountStatus?.response[7]?.count ?? 0) + (CountStatus?.response[6]?.count ?? 0) + (CountStatus?.response[9]?.count ?? 0) ?? 0)}
                    Total={"Total"}
                    STATUSTypeData
                    isPointer={true}
                  />
                </Box>
              </Box>
            </Grid>}


          {loadingCount ?
            <Box mt={5} mb={4} sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', width: !issmSmallScreen ? "25%" : "100%" }}>
              {[0, 1, 2, 3].map((row) => (
                <Skeleton
                  key={row}
                  variant="rectangular"
                  width={!issmSmallScreen ? "25%" : "100%"}
                  height={50}
                  sx={{ borderRadius: "8px", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" }}
                />
              ))}
            </Box>
            : <Box mt={4} sx={{ width: "100%", display: "flex", justifyContent: "space-between", flexDirection: !isSmallScreen ? "row" : "column" }} >

              {CRMstatusButton === BUTTON_TYPE.pending && <Box my={3}>
                <ButtonGroup sx={{ flexDirection: !issmSmallScreen ? "row" : "column", width: issmSmallScreen ? "100%" : "100%" }}>
                  <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.ALL); setFilters({ ...filters, pageNo: 1 }) }}
                    count={(CountStatus?.response[0]?.count ?? 0) + (CountStatus?.response[3]?.count ?? 0)} staticTitle={"ALL"} Title={"ALL"} STATUSWiseData={STATUSWiseData === STATUS.ALL} />
                  <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.YET_TO_RECEIVED); setFilters({ ...filters, pageNo: 1 }) }}
                    count={CountStatus?.response[0]?.count ?? 0} Title={STATUS.YET_TO_RECEIVED} STATUSWiseData={STATUSWiseData === STATUS.YET_TO_RECEIVED} />
                  <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.PENDING_EVALUATION); setFilters({ ...filters, pageNo: 1 }) }}
                    count={CountStatus?.response[3]?.count ?? 0}
                    staticTitle={"Pending Evaluation"} Title STATUSWiseData={STATUSWiseData === STATUS.PENDING_EVALUATION} />
                </ButtonGroup>  </Box>}

              {CRMstatusButton === BUTTON_TYPE.Work_In_Progress && <Box my={3}> <ButtonGroup sx={{ flexDirection: !issmSmallScreen ? "row" : "column", width: issmSmallScreen ? "100%" : "100%" }}>
                <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.ALL); setFilters({ ...filters, pageNo: 1 }) }}
                  count={(CountStatus?.response[17]?.count ?? 0) + (CountStatus?.response[1]?.count ?? 0) + (CountStatus?.response[4]?.count ?? 0) + (CountStatus?.response[5]?.count ?? 0) + (CountStatus?.response[7]?.count ?? 0)} staticTitle={"ALL"} Title STATUSWiseData={STATUSWiseData === STATUS.ALL} />

                <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.EVALUATION); setFilters({ ...filters, pageNo: 1 }) }} count={CountStatus?.response[1]?.count ?? 0} Title={STATUS.EVALUATION} STATUSWiseData={STATUSWiseData === STATUS.EVALUATION} />
                <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.SEND_TO_REPAIR); setFilters({ ...filters, pageNo: 1 }) }} count={CountStatus?.response[4]?.count ?? 0} Title={STATUS.SEND_TO_REPAIR} STATUSWiseData={STATUSWiseData === STATUS.SEND_TO_REPAIR} />
                <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.WAITING_FOR_PAYMENT); setFilters({ ...filters, pageNo: 1 }) }} count={CountStatus?.response[5]?.count} Title={STATUS.WAITING_FOR_PAYMENT} STATUSWiseData={STATUSWiseData === STATUS.WAITING_FOR_PAYMENT} />
                {/* <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.QC_CHECKED); setFilters({ ...filters, pageNo: 1 }) }} count={CountStatus?.response[17]?.count ?? 0} Title={STATUS.QC_CHECKED} STATUSWiseData={STATUSWiseData === STATUS.QC_CHECKED} /> */}
                <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.DISPATCH); setFilters({ ...filters, pageNo: 1 }) }} count={CountStatus?.response[7]?.count ?? 0} Title={STATUS.DISPATCH} STATUSWiseData={STATUSWiseData === STATUS.DISPATCH} />
              </ButtonGroup>
              </Box>}

              {CRMstatusButton === BUTTON_TYPE.Solved && <Box my={3}> <ButtonGroup sx={{ flexDirection: !issmSmallScreen ? "row" : "column", width: issmSmallScreen ? "100%" : "100%" }}>
                <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.ALL); setFilters({ ...filters, pageNo: 1 }) }}
                  count={(CountStatus?.response[9]?.count ?? 0) + (CountStatus?.response[6]?.count ?? 0) + (CountStatus?.response[15]?.count ?? 0) + (CountStatus?.response[14]?.count ?? 0)} staticTitle={"ALL"} Title STATUSWiseData={STATUSWiseData === STATUS.ALL} />
                <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.COMPLETED); setFilters({ ...filters, pageNo: 1 }) }} count={CountStatus?.response[9]?.count ?? 0} Title={STATUS.COMPLETED} STATUSWiseData={STATUSWiseData === STATUS.COMPLETED} />
                <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.NOT_DISPATCH); setFilters({ ...filters, pageNo: 1 }) }} count={CountStatus?.response[6]?.count ?? 0} Title={STATUS.NOT_DISPATCH} STATUSWiseData={STATUSWiseData === STATUS.NOT_DISPATCH} />
                <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.DEMO); setFilters({ ...filters, pageNo: 1 }) }} count={CountStatus?.response[15]?.count ?? 0} Title={STATUS.DEMO} STATUSWiseData={STATUSWiseData === STATUS.DEMO} />
                <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.REPLACEMENT_COMPLETE); setFilters({ ...filters, pageNo: 1 }) }} count={CountStatus?.response[14]?.count ?? 0} Title={STATUS.REPLACEMENT_COMPLETE} STATUSWiseData={STATUSWiseData === STATUS.REPLACEMENT_COMPLETE} />
              </ButtonGroup>
              </Box>}

              <Box sx={{ display: "flex", width: isSmallScreen ? "100%" : issmSmallScreen ? "100%" : "30%", justifyContent: "center", alignItems: "center" }}>
                <Box sx={{ display: "flex", width: "50%", mb: 2 }}>
                  <AsyncDropDown
                    defaultVal={
                      productid._id ? {
                        _id: productid._id,
                        name: productid.name,
                      } : null
                    }
                    size={true}
                    lazyFun={async (para) => await getProdutApi({ ...para, allStatus: true })}
                    OptionComponent={({ option, ...rest }) => {
                      return <ListItem {...rest}>{option.name}</ListItem >
                    }}
                    onChange={async (changedVal) => {
                      setProductid({ _id: changedVal?._id, name: changedVal?.name })
                    }}
                    titleKey={'name'}
                    valueKey={"_id"}
                    InputComponent={(params) => <TextField size='small' placeholder={"Select Product"} {...params} />}
                  />
                </Box>

                <Box
                  // my={3}
                  sx={{ display: "flex", width: !issmSmallScreen ? "50%" : !isSmallScreen ? "50%" : "100%" }}
                  pl={3}>
                  <AsyncSearchBar
                    fullWidth
                    title="Search"
                    size="small"
                    placeholder={" Search "}
                    defaultValue={filters.search}
                    onChange={(changedVal) => {
                      setFilters({ ...filters, search: changedVal });
                    }}
                  />
                </Box>
              </Box>
            </Box>}


          <Box overflow={"auto"} mt={2} height={isSmallScreens ? "70vh" : "55vh"} >
            <DataTable isSmallScreen={isSmallScreens} key={key} customRows={true} columns={columns} rows={list?.result ? list?.result : []} count={list?.total ?? 0} filters={filters} setFilters={setFilters} loading={loading} />
          </Box>
        </Paper >
      </Box >


    </>
  )
}

export default DashboardPageUI
